/**
 * 渠道参数处理
 * @param {Object} this.$route.query
 */
export const outcodeHandler = (query) => {
  const {
    xhxClickId = ''
  } = query || {}
  let outcode = ''
  // 小红书带过来的clickId参数
  if (xhxClickId) {
    outcode = `tujia_xhs_${xhxClickId}`
  }
  return outcode
}